import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CursorPosition } from './CursorPosition'
/**
* Class PageMeta
*  Meta-информация о результате постраничного запроса
*/
export class PageMeta extends ActiveModel {

  /**
  * hasBefore
  * Имеются ли записи перед возвращёнными<br>  */
  @ActiveField()
  hasBefore?: null | boolean


  /**
  * hasAfter
  * Имеются ли записи после возвращённых<br>  */
  @ActiveField()
  hasAfter?: null | boolean


  /**
  * cursorBefore
  * Данные курсора для запроса предыдущих записей<br>  */
  @ActiveField({
    factory: [CursorPosition, () => undefined]
  })
  cursorBefore?: null | CursorPosition


  /**
  * cursorAfter
  * Данные курсора для запроса следующих записей<br>  */
  @ActiveField({
    factory: [CursorPosition, () => undefined]
  })
  cursorAfter?: null | CursorPosition
}
